export default "__VITE_ASSET__sRu391Uy__"